// extracted by mini-css-extract-plugin
export default {"grid":"ProductItem_grid__BOUCb","img":"ProductItem_img__T-PWN","content":"ProductItem_content__XmKyR","details":"ProductItem_details__BmVt1","list":"ProductItem_list__e3WFr"};